import { createAsyncAction, createStandardAction } from 'typesafe-actions';
import { Page, PagesMap } from '../../Models';

export const createPage = createStandardAction('@@history/ADD_PAGE')<Page>();
export const updatePage = createStandardAction('@@history/UPDATE_PAGE')<Page>();
export const deletePage = createStandardAction('@@history/DELETE_PAGE')<Page>();

export const pageSynced = createStandardAction('@@history/PAGE_SYNCED')<Page>();

export const deleteAllPages = createStandardAction('@@history/CLEAR')();

export const refreshPagesHistory = createStandardAction('@@history/REFRESH')();

export const fetchPagesHistory = createAsyncAction(
  '@@history/fetchPages#request',
  '@@history/fetchPages#success',
  '@@history/fetchPages#error',
)<any, ReadonlyArray<Page>, Error>();

export const setPagesHistoryFromExternalSource = createStandardAction('@@history/SET_PAGES_FROM_EXTERNAL_SOURCE')<
  PagesMap
>();

export const loadPagesHistory = createStandardAction('@@history/LOAD')();
export const loadPagesHistoryError = createStandardAction('@@history/LOAD_ERROR')<any>();

export const updatePagesHistoryLastSyncDate = createStandardAction('@@history/UPDATE_LAST_SYNC_DATE')<Date>();



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/actions.ts